/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ccsl_Export_Close_LabelInputs */

const en_ccsl_export_close_label = /** @type {(inputs: Ccsl_Export_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close Modal`)
};

const fr_ccsl_export_close_label = /** @type {(inputs: Ccsl_Export_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fermer la fenetre`)
};

const de_ccsl_export_close_label = /** @type {(inputs: Ccsl_Export_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modal schließen`)
};

const it_ccsl_export_close_label = /** @type {(inputs: Ccsl_Export_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chiudi modale`)
};

const ru_ccsl_export_close_label = /** @type {(inputs: Ccsl_Export_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Закрыть модальное окно`)
};

const es_ccsl_export_close_label = /** @type {(inputs: Ccsl_Export_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerrar modal`)
};

const zh_cn2_ccsl_export_close_label = /** @type {(inputs: Ccsl_Export_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`关闭模态框`)
};

const ja_ccsl_export_close_label = /** @type {(inputs: Ccsl_Export_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`モーダルを閉じる`)
};

const hi_ccsl_export_close_label = /** @type {(inputs: Ccsl_Export_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मॉडल बंद करें`)
};

const pt_pt2_ccsl_export_close_label = /** @type {(inputs: Ccsl_Export_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fechar Modal`)
};

/**
* | output |
* | --- |
* | "Close Modal" |
*
* @param {Ccsl_Export_Close_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_close_label = /** @type {((inputs?: Ccsl_Export_Close_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_Close_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ccsl_export_close_label(inputs)
	if (locale === "de") return de_ccsl_export_close_label(inputs)
	if (locale === "it") return it_ccsl_export_close_label(inputs)
	if (locale === "ru") return ru_ccsl_export_close_label(inputs)
	if (locale === "es") return es_ccsl_export_close_label(inputs)
	if (locale === "zh-CN") return zh_cn2_ccsl_export_close_label(inputs)
	if (locale === "ja") return ja_ccsl_export_close_label(inputs)
	if (locale === "hi") return hi_ccsl_export_close_label(inputs)
	if (locale === "pt-PT") return pt_pt2_ccsl_export_close_label(inputs)
	return en_ccsl_export_close_label(inputs)
});